import React from 'react';
import Box from '@mui/material/Box';
// import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { DeleteModalIcon } from '../../media/images/DeleteModalIcon';
// import './DeleteModalStyle.scss';
import { TypesDeleteModal } from './TypeDelete';
import styles from './DeleteModalStyle.module.scss';
import { deleteTubeChartStart } from '../../Screens/VesselInformation/redux/tubeChart/tubeChartSlice';
import { RootState } from '../../redux/rootState';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 539,
  height: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: 5,
  '@media (max-width: 768px)': {
    width: '90%',
  },
};
export default function DeleteTubeChartConfirmationModal({ show, setOpenFrom }: TypesDeleteModal): JSX.Element {
  const { jobOrderId, vesselId } = useParams();
  const { tubeCharts } = useSelector((state:RootState) => state.TubeChartReducer);
  const dispatch = useDispatch();
  const deleteChart = () => {
    const payload = {
      JobOrder: String(jobOrderId),
      VesselId: String(vesselId),
    };
    dispatch(deleteTubeChartStart(payload));
    setOpenFrom();
  };

  return (
    <Modal
      open={show?.length > 0}
      onClose={setOpenFrom}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={styles.deleteIcon}>
          <DeleteModalIcon />
        </div>
        <div className={styles.modalModalHeading}>
          Are you sure?
        </div>
        <div className={styles.modalModalDescription}>
          Are you sure you want to delete the Tube Charts for this vessel?
          {' '}
          {tubeCharts?.length > 1 && 'This is a multi-offset tube chart so proceeding will delete all the charts for this vessel.'}
        </div>

        <div className={styles.divButtons}>
          <button
            type="button"
            className={`btn ${styles.deleteBtn}`}
            onClick={() => {
              deleteChart();
            }}
          >
            Yes, Delete it!
          </button>
          <button type="button" className={`btn ${styles.cancelBtn}`} onClick={setOpenFrom}>Cancel</button>
        </div>
      </Box>
    </Modal>
  );
}
